import { z } from "zod";
import { deckIdSchema } from "./decks";
import { sceneIdSchema } from "./table";
/**
 * A table's looks (ADR 0029, 0030): its scene and its deck, the owner's choice, seen by everyone.
 * Some of each belong to Club; a player may try each of those once, for three days.
 */
export const lookSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("deck"), id: deckIdSchema }),
    z.object({ kind: z.literal("scene"), id: sceneIdSchema }),
]);
/**
 * What one player may do with a look right now. `available`: a trial can start; `ended`: the
 * trial ran out and only Club brings it back (review 0015 decision 81).
 */
export const accessSchema = z.discriminatedUnion("kind", [
    z.object({ kind: z.literal("free") }),
    z.object({ kind: z.literal("club") }),
    z.object({ kind: z.literal("available") }),
    z.object({ kind: z.literal("trial"), endsAt: z.number().int() }),
    z.object({ kind: z.literal("ended"), endedAt: z.number().int() }),
]);
/** The scene and deck a player's next table starts with: their last choice while they may use it. */
export const chosenLooksSchema = z.object({ scene: sceneIdSchema, deck: deckIdSchema });
/**
 * `GET /api/looks`: every Club look with your access; `notified` once you asked to hear about Club;
 * `chosen` what your next table starts with (review 0015 decision 118).
 */
export const looksResponseSchema = z.object({
    now: z.number().int(),
    looks: z.array(z.object({ look: lookSchema, access: accessSchema, notified: z.boolean() })),
    chosen: chosenLooksSchema,
});
//# sourceMappingURL=looks.js.map